export default "__VITE_ASSET__3be93468__"